export class CodeModel {
  id: number;
  name: string;
  order?: number;
}
